<template>
  <div class="e-nav">
    <!-- PC：左侧竖排导航 -->
    <aside class="e-rail" v-if="!isMobile">
      <router-link to="/" class="e-brand">
        <img v-if="showLogo" class="e-logo" :src="logo" :alt="brandName" @error="logoError = true" />
        <span v-else class="e-mark">{{ markLetter }}</span>
      </router-link>
      <span class="e-vname" v-if="!showLogo">{{ brandName }}</span>

      <nav class="e-nav-list">
        <a href="javascript:;" :class="{ on: active === 'home' }" :title="$t('home')" @click="go('/')">
          <svg width="19" height="19" viewBox="0 0 24 24"><path d="M3 10.6 12 3.4l9 7.2V21H3z" /></svg>
        </a>
        <a href="javascript:;" :class="{ on: active === 'topup' }" :title="$t('game_top_up')" @click="goCatalog('4')">
          <svg width="19" height="19" viewBox="0 0 24 24"><path d="M13 2.5 4.5 14H11l-1 7.5L19.5 10H13z" /></svg>
        </a>
        <a href="javascript:;" :class="{ on: active === 'vouch' }" :title="$t('game_vouchers')" @click="goCatalog('5')">
          <svg width="19" height="19" viewBox="0 0 24 24"><rect x="3" y="6.5" width="18" height="11.5" rx="1.5" /><path d="M3 10.5h18" /></svg>
        </a>
        <a href="javascript:;" :class="{ on: active === 'mobile' }" :title="$t('mobile_topup')" @click="go('/mobile')">
          <svg width="19" height="19" viewBox="0 0 24 24"><rect x="6.5" y="2.5" width="11" height="19" rx="2" /><path d="M10.5 18h3" /></svg>
        </a>
        <a href="javascript:;" :class="{ on: searchOpen }" :title="$t('search')" @click="openSearch">
          <svg width="19" height="19" viewBox="0 0 24 24"><circle cx="11" cy="11" r="6.6" /><path d="m19.6 19.6-3.4-3.4" /></svg>
        </a>
      </nav>

      <div class="e-rail-ft">
        <a-dropdown placement="topLeft" :trigger="['click']">
          <a class="e-lang" href="javascript:;" @click="(e) => e.preventDefault()">{{ country }}</a>
          <a-menu class="e-langmenu" slot="overlay" @click="changeLang">
            <a-menu-item v-for="item in lang" :key="item.key">
              <a href="javascript:;">{{ item.label }}</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </aside>

    <!-- 移动端：顶栏 + 底部 Tab -->
    <template v-if="isMobile">
      <div class="e-mtop">
        <router-link to="/" class="e-brand">
          <img v-if="showLogo" class="e-logo" :src="logo" :alt="brandName" @error="logoError = true" />
          <span v-else class="e-mark">{{ markLetter }}</span>
        </router-link>
        <span class="nm" v-if="!showLogo">{{ brandName }}</span>
        <span class="ic">
          <span @click="openSearch">
            <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="6.6" /><path d="m19.6 19.6-3.4-3.4" /></svg>
          </span>
          <a-dropdown placement="bottomRight" :trigger="['click']">
            <span @click="(e) => e.preventDefault()">{{ country }}</span>
            <a-menu class="e-langmenu" slot="overlay" @click="changeLang">
              <a-menu-item v-for="item in lang" :key="item.key">
                <a href="javascript:;">{{ item.label }}</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>
      </div>

      <nav class="e-mtab">
        <a href="javascript:;" :class="{ on: active === 'home' }" @click="go('/')">
          <svg viewBox="0 0 24 24"><path d="M3 10.6 12 3.4l9 7.2V21H3z" /></svg>{{ $t('home') }}
        </a>
        <a href="javascript:;" :class="{ on: active === 'topup' }" @click="goCatalog('4')">
          <svg viewBox="0 0 24 24"><path d="M13 2.5 4.5 14H11l-1 7.5L19.5 10H13z" /></svg>{{ $t('top_up') }}
        </a>
        <a href="javascript:;" :class="{ on: active === 'vouch' }" @click="goCatalog('5')">
          <svg viewBox="0 0 24 24"><rect x="3" y="6.5" width="18" height="11.5" rx="1.5" /><path d="M3 10.5h18" /></svg>{{ $t('vouchers') }}
        </a>
        <!-- 搜索在顶栏右上角还有入口，这一格让给话费 -->
        <a href="javascript:;" :class="{ on: active === 'mobile' }" @click="go('/mobile')">
          <svg viewBox="0 0 24 24"><rect x="6.5" y="2.5" width="11" height="19" rx="2" /><path d="M10.5 18h3" /></svg>{{ $t('mobile_nav') }}
        </a>
      </nav>
    </template>

    <!-- 整页搜索覆盖层 -->
    <div class="e-srch" v-if="searchOpen">
      <div class="row">
        <svg width="22" height="22" viewBox="0 0 24 24"><circle cx="11" cy="11" r="6.6" /><path d="m19.6 19.6-3.4-3.4" /></svg>
        <SearchBox ref="search" :searchVal="searchVal" :clear="clearValue" :placeholder="$t('search')" @onsearch="handleSearch" />
        <span class="cls" @click="closeSearch">{{ $t('back') }}</span>
      </div>

      <div class="res">
        <template v-if="searchVal">
          <ul class="e-sres" v-if="gameListInfo.length > 0">
            <li class="e-lbl" style="border:0;padding-bottom:4px">{{ gameListInfo.length }} {{ $t('search_results') }}</li>
            <li v-for="item in gameListInfo" :key="item.id" @click="toPayCheckout(item.id)">
              <span class="th"><img :src="picUrl(item.gamePic)" :alt="item.gameName" /></span>
              <span>
                <p class="nm" v-html="highlightedItem(item.gameName)"></p>
                <span class="sb">{{ item.gameId }}</span>
              </span>
              <span class="go">{{ $t('game_top_up') }} →</span>
            </li>
          </ul>

          <div class="e-empty" v-else>
            <div class="ic">
              <svg width="22" height="22" viewBox="0 0 24 24"><circle cx="11" cy="11" r="6.6" /><path d="m19.6 19.6-3.4-3.4" /></svg>
            </div>
            <h4>{{ $t('no_results_found') }}</h4>
            <p>{{ $t('no_results_hint') }}</p>
            <a class="e-btn" href="javascript:;" @click="goCatalog('4')">{{ $t('game_top_up') }}</a>
          </div>
        </template>

        <div class="e-empty" v-else>
          <p>{{ $t('search_placeholder_hint') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBox from './components/searchE.vue'
import i18n from '../i18n'
import utils from '@/assets/js/common'
import dh from '@/assets/js/dHelpers'
import env from '../assets/js/env'

export default {
  components: { SearchBox },
  data() {
    return {
      isMobile: false,
      brandName: env.brandName,
      logo: env.logo,
      logoError: false,
      searchOpen: false,
      searchVal: '',
      country: 'EN',
      lang: [{ key: 'en-US', label: 'EN' }],
      gameListInfo: [],
      currency: this.$store.state.orderInfo.gameCurrency,
    }
  },
  computed: {
    // 优先展示配置里的 logo，图挂了或没配才退回字母标记
    showLogo() {
      return !!this.logo && !this.logoError
    },
    markLetter() {
      return (this.brandName || 'L').trim().charAt(0).toUpperCase()
    },
    active() {
      const path = this.$route.path
      if (path === '/') return 'home'
      if (path.indexOf('/topup/') === 0) return 'topup'
      if (path.indexOf('/mobile') === 0) return 'mobile'
      if (path.indexOf('/catalog') === 0) return (this.$route.query.type || '4') === '5' ? 'vouch' : 'topup'
      return ''
    },
  },
  watch: {
    $route() {
      this.closeSearch()
    },
  },
  mounted() {
    this.isMobile = dh.isMobileUA()

    const currentLang = localStorage.getItem('lang')

    // 语言列表按域名动态拼，与 A/B/C/D 保持一致
    if (this.currency == null) {
      const localHost = location.host;
      if (localHost.indexOf('la') > 0) {
        this.lang.push({ key: 'pt-BR', label: 'BR' }, { key: 'es-MX', label: 'MX' })
      } else if (localHost.indexOf('th') > 0) {
        this.lang.push({ key: 'th-TH', label: 'TH' })
      } else if (localHost.indexOf('ph') > 0) {
        this.lang.push({ key: 'fil-PH', label: 'PH' })
      } else if (localHost.indexOf('pg') > 0) {
        this.lang.push(
          { key: 'my-MM', label: 'MM' },
          { key: 'ms-MY', label: 'MY' },
          { key: 'vi-VN', label: 'VN' },
        )
      } else {
        this.lang.push({ key: 'id-ID', label: 'ID' })
      }
    } else {
      const currencyEnum = utils.getCurrencyByCode(this.currency)
      this.lang.push({ key: currencyEnum.language, label: currencyEnum.country })
    }

    this.lang.forEach(element => {
      if (currentLang && currentLang.indexOf(element.key) !== -1) {
        this.country = element.label
        i18n.locale = element.key
        this.$global.lang = element.label
        this.$store.commit('setCountry', element.label);
      }
    });
  },
  methods: {
    picUrl(pic) {
      return dh.gamePic(pic)
    },
    go(path) {
      this.closeSearch()
      if (this.$route.path === path) return;
      this.$router.push({ path })
    },
    goCatalog(type) {
      this.closeSearch()
      if (this.$route.path === '/catalog' && (this.$route.query.type || '4') === type) return;
      this.$router.push({ path: '/catalog', query: { type } })
    },
    openSearch() {
      this.searchOpen = true
      this.$nextTick(() => {
        const box = this.$refs.search
        if (box && box.focus) box.focus()
      })
    },
    closeSearch() {
      this.searchOpen = false
      this.searchVal = ''
      this.gameListInfo = []
      const box = this.$refs.search
      if (box) box.clearValue()
    },
    clearValue() {
      this.searchVal = '';
      this.gameListInfo = []
    },
    toPayCheckout(gameId) {
      this.closeSearch()
      this.$router.push({ path: `/topup/${gameId}` })
    },
    highlightedItem(gameName) {
      if (!this.searchVal) return gameName;
      const pattern = new RegExp(`(${this.searchVal})`, 'gi');
      return gameName.replace(pattern, '<span class="highlighted">$1</span>');
    },
    handleSearch(keyword) {
      this.searchVal = keyword
      this.fuzzyQuery(keyword)
    },
    // 搜索接口
    fuzzyQuery(gameId) {
      if (gameId === '') {
        this.gameListInfo = []
        return;
      }
      const formdata = {
        gameName: gameId,
        lang: this.country != null && this.country != '' ? this.country.toString().toLowerCase() : 'en',
      }
      this.$httpReqest('/tikishop/game/fuzzyQuery', formdata)
        .then((res) => {
          if (res.code == '200') {
            this.gameListInfo = res.gameListInfo || []
          } else {
            console.log(res.msg)
          }
        })
        .catch((err) => {
          console.log('fuzzyQuery err!', err)
        })
    },
    // 菜单 key 用语言码而不是下标，避免同级重复 key
    changeLang(obj) {
      const item = this.lang.find(l => l.key === obj.key)
      if (!item) return;
      this.country = item.label
      localStorage.setItem('lang', JSON.stringify(item.key))
      i18n.locale = item.key
      this.$global.lang = item.label;
      this.$store.commit('setCountry', item.label);
    },
  },
}
</script>

<style lang="scss" scoped>
.e-nav {
  position: relative;
}
</style>
